"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrivingLicenceStateEnum = void 0;
var DrivingLicenceStateEnum;
(function (DrivingLicenceStateEnum) {
    DrivingLicenceStateEnum["NONE"] = "NONE";
    DrivingLicenceStateEnum["REENTER_LICENCE"] = "REENTER_LICENCE";
    DrivingLicenceStateEnum["MANUAL_INPUT"] = "MANUAL_INPUT";
})(DrivingLicenceStateEnum || (exports.DrivingLicenceStateEnum = DrivingLicenceStateEnum = {}));
//# sourceMappingURL=DrivingLicenceStateEnum.js.map